import styled from "styled-components";

export const Section = styled.section`
  padding: 20px 20px;
  margin-top: 40px;
`;

export const Container = styled.div`
  width: 100%;
 
  margin: 0 auto;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const Col = styled.div`
  flex: 1;

  @media (max-width: 992px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const Title = styled.h1`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 3.1em;
  color: #06334b;
  margin-bottom: 30px;

  span {
    color: #07b6f2;
  }

  @media (max-width: 992px) {
    font-size: 2.5em;
  }

  @media (max-width: 768px) {
    font-size: 2.4em;
  }

  @media (max-width: 576px) {
    font-size: 1.89em;
    text-align: left;
  }
`;

export const Subtitle = styled.h4`
  color:#06334b;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.5em;
  margin-bottom: 2rem;

  @media (max-width: 992px) {
    font-size: 1.4em;
  }

  @media (max-width: 768px) {
    font-size: 1.3em;
  }

  @media (max-width: 576px) {
    font-size: 1em;
    text-align: left;
  }
`;

export const Paragraph = styled.p`
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1em;
  line-height: 1.91;
  color: #777777;
  text-align: justify;

  @media (max-width: 992px) {
    font-size: 0.95em;
  }

  @media (max-width: 768px) {
    font-size: 0.9em;
  }

  @media (max-width: 576px) {
    font-size: 0.91em;
  }
`;

export const ImageContainer = styled.div`
  height: fit-content;

  @media (max-width: 576px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
